import { useLocalObservable } from 'mobx-react-lite';
import { MutableRefObject, useRef } from 'react';

import { Call } from '@gem/call/CallStore/Call';
import { useCallContext } from '@gem/call/CallView/CallView.context';

import { finishAll as finishAllTask } from './Tasks/finishAll';
import { finishCall as finishCallTask } from './Tasks/finishCall';

interface IFinishCallButtonPresenter {
  isOpened: boolean;
  call: Call;
  disabledFinishCall: boolean;
  isUnauthorizedCall: boolean;
  togglePopover(): void;
  closePopover(): void;
  leaveCall(): void;
  finishCall(): void;
  finishAll(): void;
}

export const useFinishCallButtonPresenter = (): {
  buttonRef: MutableRefObject<HTMLButtonElement | null>;
  presenter: IFinishCallButtonPresenter;
} => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const context = useCallContext();

  const presenter = useLocalObservable<IFinishCallButtonPresenter>(() => ({
    isOpened: false,

    get call(): Call {
      return context.call;
    },

    get disabledFinishCall(): boolean {
      return !presenter.call.channelId;
    },

    get isUnauthorizedCall(): boolean {
      return presenter.call.isUnauthorizedCall;
    },

    togglePopover(): void {
      presenter.isOpened = !presenter.isOpened;
    },

    closePopover(): void {
      presenter.isOpened = false;
    },

    leaveCall(): void {
      finishCallTask({
        call: presenter.call,
        callController: context.callController,
      });
    },

    finishCall(): void {
      if (
        presenter.call.uiFeatures.endCallForAllEnabled &&
        presenter.call.isMeInitiatorOwnerOrAdmin
      ) {
        presenter.togglePopover();
      } else {
        presenter.leaveCall();
      }
    },

    finishAll(): void {
      finishAllTask({
        call: presenter.call,
        callController: context.callController,
      });
    },
  }));

  return {
    presenter,
    buttonRef,
  };
};
